import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";
import { trans } from "../i18n/i18n";

/**
 * Sends a request to update the selected currency.
 *
 * @param {string} currency - The new currency code (e.g., "EUR", "USD").
 * @returns {Promise<Object>} - A promise resolving to the response from the backend.
 * @throws {Error} - Throws an error if the request fails.
 */
export async function changeCurrency(currency) {
    const formData = new FormData();
    formData.append("currency", currency);

    return (await axiosInstance.post(route("jsapi.currency.set"), formData, {
        toastMsg: trans("Failed to change currency. Please try again later."),
    })).data;
}

export async function getAvailableCurrencies() {
    return (await axiosInstance.get(route("jsapi.currency.available"), {
        skipToast: true,
    })).data;
}
